/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const Wabtec = $root.Wabtec = (() => {

    /**
     * Namespace Wabtec.
     * @exports Wabtec
     * @namespace
     */
    const Wabtec = {};

    Wabtec.DataPlatform = (function() {

        /**
         * Namespace DataPlatform.
         * @memberof Wabtec
         * @namespace
         */
        const DataPlatform = {};

        DataPlatform.Common = (function() {

            /**
             * Namespace Common.
             * @memberof Wabtec.DataPlatform
             * @namespace
             */
            const Common = {};

            Common.Investigations = (function() {

                /**
                 * Namespace Investigations.
                 * @memberof Wabtec.DataPlatform.Common
                 * @namespace
                 */
                const Investigations = {};

                Investigations.RawTrackData = (function() {

                    /**
                     * Properties of a RawTrackData.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @interface IRawTrackData
                     * @property {Array.<Wabtec.DataPlatform.Common.Investigations.IRawTrackEntry>|null} [TrackEntries] RawTrackData TrackEntries
                     */

                    /**
                     * Constructs a new RawTrackData.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @classdesc Represents a RawTrackData.
                     * @implements IRawTrackData
                     * @constructor
                     * @param {Wabtec.DataPlatform.Common.Investigations.IRawTrackData=} [properties] Properties to set
                     */
                    function RawTrackData(properties) {
                        this.TrackEntries = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RawTrackData TrackEntries.
                     * @member {Array.<Wabtec.DataPlatform.Common.Investigations.IRawTrackEntry>} TrackEntries
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackData
                     * @instance
                     */
                    RawTrackData.prototype.TrackEntries = $util.emptyArray;

                    /**
                     * Decodes a RawTrackData message from the specified reader or buffer.
                     * @function decode
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {Wabtec.DataPlatform.Common.Investigations.RawTrackData} RawTrackData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawTrackData.decode = function decode(reader, length, error, long) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (long === undefined)
                            long = 0;
                        if (long > $Reader.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Wabtec.DataPlatform.Common.Investigations.RawTrackData();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    if (!(message.TrackEntries && message.TrackEntries.length))
                                        message.TrackEntries = [];
                                    message.TrackEntries.push($root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.decode(reader, reader.uint32(), undefined, long + 1));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7, long);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a RawTrackData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {Wabtec.DataPlatform.Common.Investigations.RawTrackData} RawTrackData
                     */
                    RawTrackData.fromObject = function fromObject(object, long) {
                        if (object instanceof $root.Wabtec.DataPlatform.Common.Investigations.RawTrackData)
                            return object;
                        if (long === undefined)
                            long = 0;
                        if (long > $util.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let message = new $root.Wabtec.DataPlatform.Common.Investigations.RawTrackData();
                        if (object.TrackEntries) {
                            if (!Array.isArray(object.TrackEntries))
                                throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackData.TrackEntries: array expected");
                            message.TrackEntries = [];
                            for (let i = 0; i < object.TrackEntries.length; ++i) {
                                if (typeof object.TrackEntries[i] !== "object")
                                    throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackData.TrackEntries: object expected");
                                message.TrackEntries[i] = $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.fromObject(object.TrackEntries[i], long + 1);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a RawTrackData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackData
                     * @static
                     * @param {Wabtec.DataPlatform.Common.Investigations.RawTrackData} message RawTrackData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RawTrackData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.TrackEntries = [];
                        if (message.TrackEntries && message.TrackEntries.length) {
                            object.TrackEntries = [];
                            for (let j = 0; j < message.TrackEntries.length; ++j)
                                object.TrackEntries[j] = $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.toObject(message.TrackEntries[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this RawTrackData to JSON.
                     * @function toJSON
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RawTrackData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RawTrackData
                     * @function getTypeUrl
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackData
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RawTrackData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/Wabtec.DataPlatform.Common.Investigations.RawTrackData";
                    };

                    return RawTrackData;
                })();

                Investigations.RawTrackEntry = (function() {

                    /**
                     * Properties of a RawTrackEntry.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @interface IRawTrackEntry
                     * @property {google.protobuf.ITimestamp|null} [GpsTime] RawTrackEntry GpsTime
                     * @property {google.protobuf.ITimestamp|null} [CasWebRecieveTime] RawTrackEntry CasWebRecieveTime
                     * @property {number|Long|null} [AssetId] RawTrackEntry AssetId
                     * @property {string|null} [AssetName] RawTrackEntry AssetName
                     * @property {number|null} [EventId] RawTrackEntry EventId
                     * @property {number|null} [EventTypeId] RawTrackEntry EventTypeId
                     * @property {number|null} [Latitude] RawTrackEntry Latitude
                     * @property {number|null} [Longitude] RawTrackEntry Longitude
                     * @property {number|null} [Altitude] RawTrackEntry Altitude
                     * @property {number|null} [Heading] RawTrackEntry Heading
                     * @property {number|null} [Speed] RawTrackEntry Speed
                     * @property {number|null} [Gear] RawTrackEntry Gear
                     * @property {boolean|null} [Forward] RawTrackEntry Forward
                     * @property {boolean|null} [Reverse] RawTrackEntry Reverse
                     * @property {boolean|null} [Ignition] RawTrackEntry Ignition
                     * @property {Array.<Wabtec.DataPlatform.Common.Investigations.IRawIdToIdAndName>|null} [GeofenceAt] RawTrackEntry GeofenceAt
                     * @property {Array.<Wabtec.DataPlatform.Common.Investigations.IRawNameToId>|null} [VehiclesInView] RawTrackEntry VehiclesInView
                     * @property {string|null} [RuleName] RawTrackEntry RuleName
                     * @property {number|Long|null} [SatelliteCount] RawTrackEntry SatelliteCount
                     * @property {number|null} [Hdop] RawTrackEntry Hdop
                     * @property {number|null} [Vdop] RawTrackEntry Vdop
                     * @property {number|null} [HorizontalAccuracy] RawTrackEntry HorizontalAccuracy
                     * @property {number|null} [VerticalAccuracy] RawTrackEntry VerticalAccuracy
                     * @property {boolean|null} [ValidFix] RawTrackEntry ValidFix
                     * @property {boolean|null} [GpsAntennaStatus] RawTrackEntry GpsAntennaStatus
                     * @property {number|null} [MessageQuality] RawTrackEntry MessageQuality
                     * @property {number|null} [SelfTestFaultCount] RawTrackEntry SelfTestFaultCount
                     * @property {Array.<Wabtec.DataPlatform.Common.Investigations.ISelfTestFailure>|null} [SelfTestFailures] RawTrackEntry SelfTestFailures
                     * @property {number|null} [OtherVehicleDistance] RawTrackEntry OtherVehicleDistance
                     * @property {boolean|null} [Audible] RawTrackEntry Audible
                     * @property {Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.TrackEntryType|null} [EntryType] RawTrackEntry EntryType
                     * @property {number|null} [InnerBeamLength] RawTrackEntry InnerBeamLength
                     * @property {number|null} [OuterBeamLength] RawTrackEntry OuterBeamLength
                     * @property {number|null} [MotiveState] RawTrackEntry MotiveState
                     * @property {number|null} [Payload] RawTrackEntry Payload
                     * @property {number|null} [Gradient] RawTrackEntry Gradient
                     * @property {boolean|null} [Level9Active] RawTrackEntry Level9Active
                     * @property {string|null} [Level9Action] RawTrackEntry Level9Action
                     * @property {number|null} [Level9Level] RawTrackEntry Level9Level
                     * @property {string|null} [OtherVehicleName] RawTrackEntry OtherVehicleName
                     * @property {boolean|null} [OtherVehicleIsDotNetix] RawTrackEntry OtherVehicleIsDotNetix
                     * @property {Array.<Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.InteractionCharacteristicsType>|null} [InteractionCharacteristics] RawTrackEntry InteractionCharacteristics
                     * @property {number|null} [HorizAccuracySecondaryGNSS] RawTrackEntry HorizAccuracySecondaryGNSS
                     */

                    /**
                     * Constructs a new RawTrackEntry.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @classdesc Represents a RawTrackEntry.
                     * @implements IRawTrackEntry
                     * @constructor
                     * @param {Wabtec.DataPlatform.Common.Investigations.IRawTrackEntry=} [properties] Properties to set
                     */
                    function RawTrackEntry(properties) {
                        this.GeofenceAt = [];
                        this.VehiclesInView = [];
                        this.SelfTestFailures = [];
                        this.InteractionCharacteristics = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RawTrackEntry GpsTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} GpsTime
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.GpsTime = null;

                    /**
                     * RawTrackEntry CasWebRecieveTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} CasWebRecieveTime
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.CasWebRecieveTime = null;

                    /**
                     * RawTrackEntry AssetId.
                     * @member {number|Long} AssetId
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.AssetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * RawTrackEntry AssetName.
                     * @member {string} AssetName
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.AssetName = "";

                    /**
                     * RawTrackEntry EventId.
                     * @member {number|null|undefined} EventId
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.EventId = null;

                    /**
                     * RawTrackEntry EventTypeId.
                     * @member {number|null|undefined} EventTypeId
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.EventTypeId = null;

                    /**
                     * RawTrackEntry Latitude.
                     * @member {number} Latitude
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Latitude = 0;

                    /**
                     * RawTrackEntry Longitude.
                     * @member {number} Longitude
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Longitude = 0;

                    /**
                     * RawTrackEntry Altitude.
                     * @member {number} Altitude
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Altitude = 0;

                    /**
                     * RawTrackEntry Heading.
                     * @member {number} Heading
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Heading = 0;

                    /**
                     * RawTrackEntry Speed.
                     * @member {number} Speed
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Speed = 0;

                    /**
                     * RawTrackEntry Gear.
                     * @member {number|null|undefined} Gear
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Gear = null;

                    /**
                     * RawTrackEntry Forward.
                     * @member {boolean|null|undefined} Forward
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Forward = null;

                    /**
                     * RawTrackEntry Reverse.
                     * @member {boolean|null|undefined} Reverse
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Reverse = null;

                    /**
                     * RawTrackEntry Ignition.
                     * @member {boolean} Ignition
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Ignition = false;

                    /**
                     * RawTrackEntry GeofenceAt.
                     * @member {Array.<Wabtec.DataPlatform.Common.Investigations.IRawIdToIdAndName>} GeofenceAt
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.GeofenceAt = $util.emptyArray;

                    /**
                     * RawTrackEntry VehiclesInView.
                     * @member {Array.<Wabtec.DataPlatform.Common.Investigations.IRawNameToId>} VehiclesInView
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.VehiclesInView = $util.emptyArray;

                    /**
                     * RawTrackEntry RuleName.
                     * @member {string} RuleName
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.RuleName = "";

                    /**
                     * RawTrackEntry SatelliteCount.
                     * @member {number|Long|null|undefined} SatelliteCount
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.SatelliteCount = null;

                    /**
                     * RawTrackEntry Hdop.
                     * @member {number|null|undefined} Hdop
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Hdop = null;

                    /**
                     * RawTrackEntry Vdop.
                     * @member {number|null|undefined} Vdop
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Vdop = null;

                    /**
                     * RawTrackEntry HorizontalAccuracy.
                     * @member {number|null|undefined} HorizontalAccuracy
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.HorizontalAccuracy = null;

                    /**
                     * RawTrackEntry VerticalAccuracy.
                     * @member {number|null|undefined} VerticalAccuracy
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.VerticalAccuracy = null;

                    /**
                     * RawTrackEntry ValidFix.
                     * @member {boolean} ValidFix
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.ValidFix = false;

                    /**
                     * RawTrackEntry GpsAntennaStatus.
                     * @member {boolean|null|undefined} GpsAntennaStatus
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.GpsAntennaStatus = null;

                    /**
                     * RawTrackEntry MessageQuality.
                     * @member {number} MessageQuality
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.MessageQuality = 0;

                    /**
                     * RawTrackEntry SelfTestFaultCount.
                     * @member {number} SelfTestFaultCount
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.SelfTestFaultCount = 0;

                    /**
                     * RawTrackEntry SelfTestFailures.
                     * @member {Array.<Wabtec.DataPlatform.Common.Investigations.ISelfTestFailure>} SelfTestFailures
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.SelfTestFailures = $util.emptyArray;

                    /**
                     * RawTrackEntry OtherVehicleDistance.
                     * @member {number|null|undefined} OtherVehicleDistance
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.OtherVehicleDistance = null;

                    /**
                     * RawTrackEntry Audible.
                     * @member {boolean|null|undefined} Audible
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Audible = null;

                    /**
                     * RawTrackEntry EntryType.
                     * @member {Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.TrackEntryType} EntryType
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.EntryType = 0;

                    /**
                     * RawTrackEntry InnerBeamLength.
                     * @member {number|null|undefined} InnerBeamLength
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.InnerBeamLength = null;

                    /**
                     * RawTrackEntry OuterBeamLength.
                     * @member {number|null|undefined} OuterBeamLength
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.OuterBeamLength = null;

                    /**
                     * RawTrackEntry MotiveState.
                     * @member {number|null|undefined} MotiveState
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.MotiveState = null;

                    /**
                     * RawTrackEntry Payload.
                     * @member {number|null|undefined} Payload
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Payload = null;

                    /**
                     * RawTrackEntry Gradient.
                     * @member {number|null|undefined} Gradient
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Gradient = null;

                    /**
                     * RawTrackEntry Level9Active.
                     * @member {boolean|null|undefined} Level9Active
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Level9Active = null;

                    /**
                     * RawTrackEntry Level9Action.
                     * @member {string|null|undefined} Level9Action
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Level9Action = null;

                    /**
                     * RawTrackEntry Level9Level.
                     * @member {number|null|undefined} Level9Level
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.Level9Level = null;

                    /**
                     * RawTrackEntry OtherVehicleName.
                     * @member {string|null|undefined} OtherVehicleName
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.OtherVehicleName = null;

                    /**
                     * RawTrackEntry OtherVehicleIsDotNetix.
                     * @member {boolean|null|undefined} OtherVehicleIsDotNetix
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.OtherVehicleIsDotNetix = null;

                    /**
                     * RawTrackEntry InteractionCharacteristics.
                     * @member {Array.<Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.InteractionCharacteristicsType>} InteractionCharacteristics
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.InteractionCharacteristics = $util.emptyArray;

                    /**
                     * RawTrackEntry HorizAccuracySecondaryGNSS.
                     * @member {number|null|undefined} HorizAccuracySecondaryGNSS
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    RawTrackEntry.prototype.HorizAccuracySecondaryGNSS = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * RawTrackEntry _EventId.
                     * @member {"EventId"|undefined} _EventId
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_EventId", {
                        get: $util.oneOfGetter($oneOfFields = ["EventId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _EventTypeId.
                     * @member {"EventTypeId"|undefined} _EventTypeId
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_EventTypeId", {
                        get: $util.oneOfGetter($oneOfFields = ["EventTypeId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Gear.
                     * @member {"Gear"|undefined} _Gear
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Gear", {
                        get: $util.oneOfGetter($oneOfFields = ["Gear"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Forward.
                     * @member {"Forward"|undefined} _Forward
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Forward", {
                        get: $util.oneOfGetter($oneOfFields = ["Forward"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Reverse.
                     * @member {"Reverse"|undefined} _Reverse
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Reverse", {
                        get: $util.oneOfGetter($oneOfFields = ["Reverse"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _SatelliteCount.
                     * @member {"SatelliteCount"|undefined} _SatelliteCount
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_SatelliteCount", {
                        get: $util.oneOfGetter($oneOfFields = ["SatelliteCount"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Hdop.
                     * @member {"Hdop"|undefined} _Hdop
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Hdop", {
                        get: $util.oneOfGetter($oneOfFields = ["Hdop"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Vdop.
                     * @member {"Vdop"|undefined} _Vdop
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Vdop", {
                        get: $util.oneOfGetter($oneOfFields = ["Vdop"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _HorizontalAccuracy.
                     * @member {"HorizontalAccuracy"|undefined} _HorizontalAccuracy
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_HorizontalAccuracy", {
                        get: $util.oneOfGetter($oneOfFields = ["HorizontalAccuracy"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _VerticalAccuracy.
                     * @member {"VerticalAccuracy"|undefined} _VerticalAccuracy
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_VerticalAccuracy", {
                        get: $util.oneOfGetter($oneOfFields = ["VerticalAccuracy"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _GpsAntennaStatus.
                     * @member {"GpsAntennaStatus"|undefined} _GpsAntennaStatus
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_GpsAntennaStatus", {
                        get: $util.oneOfGetter($oneOfFields = ["GpsAntennaStatus"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _OtherVehicleDistance.
                     * @member {"OtherVehicleDistance"|undefined} _OtherVehicleDistance
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_OtherVehicleDistance", {
                        get: $util.oneOfGetter($oneOfFields = ["OtherVehicleDistance"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Audible.
                     * @member {"Audible"|undefined} _Audible
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Audible", {
                        get: $util.oneOfGetter($oneOfFields = ["Audible"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _InnerBeamLength.
                     * @member {"InnerBeamLength"|undefined} _InnerBeamLength
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_InnerBeamLength", {
                        get: $util.oneOfGetter($oneOfFields = ["InnerBeamLength"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _OuterBeamLength.
                     * @member {"OuterBeamLength"|undefined} _OuterBeamLength
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_OuterBeamLength", {
                        get: $util.oneOfGetter($oneOfFields = ["OuterBeamLength"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _MotiveState.
                     * @member {"MotiveState"|undefined} _MotiveState
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_MotiveState", {
                        get: $util.oneOfGetter($oneOfFields = ["MotiveState"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Payload.
                     * @member {"Payload"|undefined} _Payload
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Payload", {
                        get: $util.oneOfGetter($oneOfFields = ["Payload"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Gradient.
                     * @member {"Gradient"|undefined} _Gradient
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Gradient", {
                        get: $util.oneOfGetter($oneOfFields = ["Gradient"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Level9Active.
                     * @member {"Level9Active"|undefined} _Level9Active
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Level9Active", {
                        get: $util.oneOfGetter($oneOfFields = ["Level9Active"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Level9Action.
                     * @member {"Level9Action"|undefined} _Level9Action
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Level9Action", {
                        get: $util.oneOfGetter($oneOfFields = ["Level9Action"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _Level9Level.
                     * @member {"Level9Level"|undefined} _Level9Level
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_Level9Level", {
                        get: $util.oneOfGetter($oneOfFields = ["Level9Level"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _OtherVehicleName.
                     * @member {"OtherVehicleName"|undefined} _OtherVehicleName
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_OtherVehicleName", {
                        get: $util.oneOfGetter($oneOfFields = ["OtherVehicleName"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _OtherVehicleIsDotNetix.
                     * @member {"OtherVehicleIsDotNetix"|undefined} _OtherVehicleIsDotNetix
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_OtherVehicleIsDotNetix", {
                        get: $util.oneOfGetter($oneOfFields = ["OtherVehicleIsDotNetix"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawTrackEntry _HorizAccuracySecondaryGNSS.
                     * @member {"HorizAccuracySecondaryGNSS"|undefined} _HorizAccuracySecondaryGNSS
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     */
                    Object.defineProperty(RawTrackEntry.prototype, "_HorizAccuracySecondaryGNSS", {
                        get: $util.oneOfGetter($oneOfFields = ["HorizAccuracySecondaryGNSS"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Decodes a RawTrackEntry message from the specified reader or buffer.
                     * @function decode
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {Wabtec.DataPlatform.Common.Investigations.RawTrackEntry} RawTrackEntry
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawTrackEntry.decode = function decode(reader, length, error, long) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (long === undefined)
                            long = 0;
                        if (long > $Reader.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.GpsTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                    break;
                                }
                            case 2: {
                                    message.CasWebRecieveTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32(), undefined, long + 1);
                                    break;
                                }
                            case 3: {
                                    message.AssetId = reader.int64();
                                    break;
                                }
                            case 4: {
                                    message.AssetName = reader.string();
                                    break;
                                }
                            case 5: {
                                    message.EventId = reader.int32();
                                    break;
                                }
                            case 6: {
                                    message.EventTypeId = reader.int32();
                                    break;
                                }
                            case 7: {
                                    message.Latitude = reader.double();
                                    break;
                                }
                            case 8: {
                                    message.Longitude = reader.double();
                                    break;
                                }
                            case 9: {
                                    message.Altitude = reader.double();
                                    break;
                                }
                            case 10: {
                                    message.Heading = reader.float();
                                    break;
                                }
                            case 11: {
                                    message.Speed = reader.float();
                                    break;
                                }
                            case 12: {
                                    message.Gear = reader.int32();
                                    break;
                                }
                            case 13: {
                                    message.Forward = reader.bool();
                                    break;
                                }
                            case 14: {
                                    message.Reverse = reader.bool();
                                    break;
                                }
                            case 15: {
                                    message.Ignition = reader.bool();
                                    break;
                                }
                            case 16: {
                                    if (!(message.GeofenceAt && message.GeofenceAt.length))
                                        message.GeofenceAt = [];
                                    message.GeofenceAt.push($root.Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName.decode(reader, reader.uint32(), undefined, long + 1));
                                    break;
                                }
                            case 17: {
                                    if (!(message.VehiclesInView && message.VehiclesInView.length))
                                        message.VehiclesInView = [];
                                    message.VehiclesInView.push($root.Wabtec.DataPlatform.Common.Investigations.RawNameToId.decode(reader, reader.uint32(), undefined, long + 1));
                                    break;
                                }
                            case 18: {
                                    message.RuleName = reader.string();
                                    break;
                                }
                            case 19: {
                                    message.SatelliteCount = reader.int64();
                                    break;
                                }
                            case 20: {
                                    message.Hdop = reader.float();
                                    break;
                                }
                            case 21: {
                                    message.Vdop = reader.float();
                                    break;
                                }
                            case 22: {
                                    message.HorizontalAccuracy = reader.float();
                                    break;
                                }
                            case 23: {
                                    message.VerticalAccuracy = reader.float();
                                    break;
                                }
                            case 24: {
                                    message.ValidFix = reader.bool();
                                    break;
                                }
                            case 25: {
                                    message.GpsAntennaStatus = reader.bool();
                                    break;
                                }
                            case 26: {
                                    message.MessageQuality = reader.int32();
                                    break;
                                }
                            case 27: {
                                    message.SelfTestFaultCount = reader.int32();
                                    break;
                                }
                            case 28: {
                                    if (!(message.SelfTestFailures && message.SelfTestFailures.length))
                                        message.SelfTestFailures = [];
                                    message.SelfTestFailures.push($root.Wabtec.DataPlatform.Common.Investigations.SelfTestFailure.decode(reader, reader.uint32(), undefined, long + 1));
                                    break;
                                }
                            case 29: {
                                    message.OtherVehicleDistance = reader.float();
                                    break;
                                }
                            case 30: {
                                    message.Audible = reader.bool();
                                    break;
                                }
                            case 31: {
                                    message.EntryType = reader.int32();
                                    break;
                                }
                            case 32: {
                                    message.InnerBeamLength = reader.double();
                                    break;
                                }
                            case 33: {
                                    message.OuterBeamLength = reader.double();
                                    break;
                                }
                            case 34: {
                                    message.MotiveState = reader.int32();
                                    break;
                                }
                            case 35: {
                                    message.Payload = reader.int32();
                                    break;
                                }
                            case 36: {
                                    message.Gradient = reader.float();
                                    break;
                                }
                            case 37: {
                                    message.Level9Active = reader.bool();
                                    break;
                                }
                            case 38: {
                                    message.Level9Action = reader.string();
                                    break;
                                }
                            case 39: {
                                    message.Level9Level = reader.int32();
                                    break;
                                }
                            case 40: {
                                    message.OtherVehicleName = reader.string();
                                    break;
                                }
                            case 41: {
                                    message.OtherVehicleIsDotNetix = reader.bool();
                                    break;
                                }
                            case 42: {
                                    if (!(message.InteractionCharacteristics && message.InteractionCharacteristics.length))
                                        message.InteractionCharacteristics = [];
                                    if ((tag & 7) === 2) {
                                        let end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.InteractionCharacteristics.push(reader.int32());
                                    } else
                                        message.InteractionCharacteristics.push(reader.int32());
                                    break;
                                }
                            case 43: {
                                    message.HorizAccuracySecondaryGNSS = reader.float();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7, long);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a RawTrackEntry message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {Wabtec.DataPlatform.Common.Investigations.RawTrackEntry} RawTrackEntry
                     */
                    RawTrackEntry.fromObject = function fromObject(object, long) {
                        if (object instanceof $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry)
                            return object;
                        if (long === undefined)
                            long = 0;
                        if (long > $util.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let message = new $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry();
                        if (object.GpsTime != null) {
                            if (typeof object.GpsTime !== "object")
                                throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.GpsTime: object expected");
                            message.GpsTime = $root.google.protobuf.Timestamp.fromObject(object.GpsTime, long + 1);
                        }
                        if (object.CasWebRecieveTime != null) {
                            if (typeof object.CasWebRecieveTime !== "object")
                                throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.CasWebRecieveTime: object expected");
                            message.CasWebRecieveTime = $root.google.protobuf.Timestamp.fromObject(object.CasWebRecieveTime, long + 1);
                        }
                        if (object.AssetId != null)
                            if ($util.Long)
                                (message.AssetId = $util.Long.fromValue(object.AssetId)).unsigned = false;
                            else if (typeof object.AssetId === "string")
                                message.AssetId = parseInt(object.AssetId, 10);
                            else if (typeof object.AssetId === "number")
                                message.AssetId = object.AssetId;
                            else if (typeof object.AssetId === "object")
                                message.AssetId = new $util.LongBits(object.AssetId.low >>> 0, object.AssetId.high >>> 0).toNumber();
                        if (object.AssetName != null)
                            message.AssetName = String(object.AssetName);
                        if (object.EventId != null)
                            message.EventId = object.EventId | 0;
                        if (object.EventTypeId != null)
                            message.EventTypeId = object.EventTypeId | 0;
                        if (object.Latitude != null)
                            message.Latitude = Number(object.Latitude);
                        if (object.Longitude != null)
                            message.Longitude = Number(object.Longitude);
                        if (object.Altitude != null)
                            message.Altitude = Number(object.Altitude);
                        if (object.Heading != null)
                            message.Heading = Number(object.Heading);
                        if (object.Speed != null)
                            message.Speed = Number(object.Speed);
                        if (object.Gear != null)
                            message.Gear = object.Gear | 0;
                        if (object.Forward != null)
                            message.Forward = Boolean(object.Forward);
                        if (object.Reverse != null)
                            message.Reverse = Boolean(object.Reverse);
                        if (object.Ignition != null)
                            message.Ignition = Boolean(object.Ignition);
                        if (object.GeofenceAt) {
                            if (!Array.isArray(object.GeofenceAt))
                                throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.GeofenceAt: array expected");
                            message.GeofenceAt = [];
                            for (let i = 0; i < object.GeofenceAt.length; ++i) {
                                if (typeof object.GeofenceAt[i] !== "object")
                                    throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.GeofenceAt: object expected");
                                message.GeofenceAt[i] = $root.Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName.fromObject(object.GeofenceAt[i], long + 1);
                            }
                        }
                        if (object.VehiclesInView) {
                            if (!Array.isArray(object.VehiclesInView))
                                throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.VehiclesInView: array expected");
                            message.VehiclesInView = [];
                            for (let i = 0; i < object.VehiclesInView.length; ++i) {
                                if (typeof object.VehiclesInView[i] !== "object")
                                    throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.VehiclesInView: object expected");
                                message.VehiclesInView[i] = $root.Wabtec.DataPlatform.Common.Investigations.RawNameToId.fromObject(object.VehiclesInView[i], long + 1);
                            }
                        }
                        if (object.RuleName != null)
                            message.RuleName = String(object.RuleName);
                        if (object.SatelliteCount != null)
                            if ($util.Long)
                                (message.SatelliteCount = $util.Long.fromValue(object.SatelliteCount)).unsigned = false;
                            else if (typeof object.SatelliteCount === "string")
                                message.SatelliteCount = parseInt(object.SatelliteCount, 10);
                            else if (typeof object.SatelliteCount === "number")
                                message.SatelliteCount = object.SatelliteCount;
                            else if (typeof object.SatelliteCount === "object")
                                message.SatelliteCount = new $util.LongBits(object.SatelliteCount.low >>> 0, object.SatelliteCount.high >>> 0).toNumber();
                        if (object.Hdop != null)
                            message.Hdop = Number(object.Hdop);
                        if (object.Vdop != null)
                            message.Vdop = Number(object.Vdop);
                        if (object.HorizontalAccuracy != null)
                            message.HorizontalAccuracy = Number(object.HorizontalAccuracy);
                        if (object.VerticalAccuracy != null)
                            message.VerticalAccuracy = Number(object.VerticalAccuracy);
                        if (object.ValidFix != null)
                            message.ValidFix = Boolean(object.ValidFix);
                        if (object.GpsAntennaStatus != null)
                            message.GpsAntennaStatus = Boolean(object.GpsAntennaStatus);
                        if (object.MessageQuality != null)
                            message.MessageQuality = object.MessageQuality | 0;
                        if (object.SelfTestFaultCount != null)
                            message.SelfTestFaultCount = object.SelfTestFaultCount | 0;
                        if (object.SelfTestFailures) {
                            if (!Array.isArray(object.SelfTestFailures))
                                throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.SelfTestFailures: array expected");
                            message.SelfTestFailures = [];
                            for (let i = 0; i < object.SelfTestFailures.length; ++i) {
                                if (typeof object.SelfTestFailures[i] !== "object")
                                    throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.SelfTestFailures: object expected");
                                message.SelfTestFailures[i] = $root.Wabtec.DataPlatform.Common.Investigations.SelfTestFailure.fromObject(object.SelfTestFailures[i], long + 1);
                            }
                        }
                        if (object.OtherVehicleDistance != null)
                            message.OtherVehicleDistance = Number(object.OtherVehicleDistance);
                        if (object.Audible != null)
                            message.Audible = Boolean(object.Audible);
                        switch (object.EntryType) {
                        default:
                            if (typeof object.EntryType === "number") {
                                message.EntryType = object.EntryType;
                                break;
                            }
                            break;
                        case "None":
                        case 0:
                            message.EntryType = 0;
                            break;
                        case "InteractionStart":
                        case 1:
                            message.EntryType = 1;
                            break;
                        case "InteractionEnd":
                        case 2:
                            message.EntryType = 2;
                            break;
                        }
                        if (object.InnerBeamLength != null)
                            message.InnerBeamLength = Number(object.InnerBeamLength);
                        if (object.OuterBeamLength != null)
                            message.OuterBeamLength = Number(object.OuterBeamLength);
                        if (object.MotiveState != null)
                            message.MotiveState = object.MotiveState | 0;
                        if (object.Payload != null)
                            message.Payload = object.Payload | 0;
                        if (object.Gradient != null)
                            message.Gradient = Number(object.Gradient);
                        if (object.Level9Active != null)
                            message.Level9Active = Boolean(object.Level9Active);
                        if (object.Level9Action != null)
                            message.Level9Action = String(object.Level9Action);
                        if (object.Level9Level != null)
                            message.Level9Level = object.Level9Level | 0;
                        if (object.OtherVehicleName != null)
                            message.OtherVehicleName = String(object.OtherVehicleName);
                        if (object.OtherVehicleIsDotNetix != null)
                            message.OtherVehicleIsDotNetix = Boolean(object.OtherVehicleIsDotNetix);
                        if (object.InteractionCharacteristics) {
                            if (!Array.isArray(object.InteractionCharacteristics))
                                throw TypeError(".Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.InteractionCharacteristics: array expected");
                            message.InteractionCharacteristics = [];
                            for (let i = 0; i < object.InteractionCharacteristics.length; ++i)
                                switch (object.InteractionCharacteristics[i]) {
                                default:
                                    if (typeof object.InteractionCharacteristics[i] === "number") {
                                        message.InteractionCharacteristics[i] = object.InteractionCharacteristics[i];
                                        break;
                                    }
                                case "IntersectionGeofence":
                                case 0:
                                    message.InteractionCharacteristics[i] = 0;
                                    break;
                                case "WetRoadGeofence":
                                case 1:
                                    message.InteractionCharacteristics[i] = 1;
                                    break;
                                case "SlopedGeofence":
                                case 2:
                                    message.InteractionCharacteristics[i] = 2;
                                    break;
                                case "WetRoad":
                                case 3:
                                    message.InteractionCharacteristics[i] = 3;
                                    break;
                                case "Roadworks":
                                case 4:
                                    message.InteractionCharacteristics[i] = 4;
                                    break;
                                case "Loaded":
                                case 5:
                                    message.InteractionCharacteristics[i] = 5;
                                    break;
                                case "Intervention":
                                case 6:
                                    message.InteractionCharacteristics[i] = 6;
                                    break;
                                }
                        }
                        if (object.HorizAccuracySecondaryGNSS != null)
                            message.HorizAccuracySecondaryGNSS = Number(object.HorizAccuracySecondaryGNSS);
                        return message;
                    };

                    /**
                     * Creates a plain object from a RawTrackEntry message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @static
                     * @param {Wabtec.DataPlatform.Common.Investigations.RawTrackEntry} message RawTrackEntry
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RawTrackEntry.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults) {
                            object.GeofenceAt = [];
                            object.VehiclesInView = [];
                            object.SelfTestFailures = [];
                            object.InteractionCharacteristics = [];
                        }
                        if (options.defaults) {
                            object.GpsTime = null;
                            object.CasWebRecieveTime = null;
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.AssetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.AssetId = options.longs === String ? "0" : 0;
                            object.AssetName = "";
                            object.Latitude = 0;
                            object.Longitude = 0;
                            object.Altitude = 0;
                            object.Heading = 0;
                            object.Speed = 0;
                            object.Ignition = false;
                            object.RuleName = "";
                            object.ValidFix = false;
                            object.MessageQuality = 0;
                            object.SelfTestFaultCount = 0;
                            object.EntryType = options.enums === String ? "None" : 0;
                        }
                        if (message.GpsTime != null && message.hasOwnProperty("GpsTime"))
                            object.GpsTime = $root.google.protobuf.Timestamp.toObject(message.GpsTime, options);
                        if (message.CasWebRecieveTime != null && message.hasOwnProperty("CasWebRecieveTime"))
                            object.CasWebRecieveTime = $root.google.protobuf.Timestamp.toObject(message.CasWebRecieveTime, options);
                        if (message.AssetId != null && message.hasOwnProperty("AssetId"))
                            if (typeof message.AssetId === "number")
                                object.AssetId = options.longs === String ? String(message.AssetId) : message.AssetId;
                            else
                                object.AssetId = options.longs === String ? $util.Long.prototype.toString.call(message.AssetId) : options.longs === Number ? new $util.LongBits(message.AssetId.low >>> 0, message.AssetId.high >>> 0).toNumber() : message.AssetId;
                        if (message.AssetName != null && message.hasOwnProperty("AssetName"))
                            object.AssetName = message.AssetName;
                        if (message.EventId != null && message.hasOwnProperty("EventId")) {
                            object.EventId = message.EventId;
                            if (options.oneofs)
                                object._EventId = "EventId";
                        }
                        if (message.EventTypeId != null && message.hasOwnProperty("EventTypeId")) {
                            object.EventTypeId = message.EventTypeId;
                            if (options.oneofs)
                                object._EventTypeId = "EventTypeId";
                        }
                        if (message.Latitude != null && message.hasOwnProperty("Latitude"))
                            object.Latitude = options.json && !isFinite(message.Latitude) ? String(message.Latitude) : message.Latitude;
                        if (message.Longitude != null && message.hasOwnProperty("Longitude"))
                            object.Longitude = options.json && !isFinite(message.Longitude) ? String(message.Longitude) : message.Longitude;
                        if (message.Altitude != null && message.hasOwnProperty("Altitude"))
                            object.Altitude = options.json && !isFinite(message.Altitude) ? String(message.Altitude) : message.Altitude;
                        if (message.Heading != null && message.hasOwnProperty("Heading"))
                            object.Heading = options.json && !isFinite(message.Heading) ? String(message.Heading) : message.Heading;
                        if (message.Speed != null && message.hasOwnProperty("Speed"))
                            object.Speed = options.json && !isFinite(message.Speed) ? String(message.Speed) : message.Speed;
                        if (message.Gear != null && message.hasOwnProperty("Gear")) {
                            object.Gear = message.Gear;
                            if (options.oneofs)
                                object._Gear = "Gear";
                        }
                        if (message.Forward != null && message.hasOwnProperty("Forward")) {
                            object.Forward = message.Forward;
                            if (options.oneofs)
                                object._Forward = "Forward";
                        }
                        if (message.Reverse != null && message.hasOwnProperty("Reverse")) {
                            object.Reverse = message.Reverse;
                            if (options.oneofs)
                                object._Reverse = "Reverse";
                        }
                        if (message.Ignition != null && message.hasOwnProperty("Ignition"))
                            object.Ignition = message.Ignition;
                        if (message.GeofenceAt && message.GeofenceAt.length) {
                            object.GeofenceAt = [];
                            for (let j = 0; j < message.GeofenceAt.length; ++j)
                                object.GeofenceAt[j] = $root.Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName.toObject(message.GeofenceAt[j], options);
                        }
                        if (message.VehiclesInView && message.VehiclesInView.length) {
                            object.VehiclesInView = [];
                            for (let j = 0; j < message.VehiclesInView.length; ++j)
                                object.VehiclesInView[j] = $root.Wabtec.DataPlatform.Common.Investigations.RawNameToId.toObject(message.VehiclesInView[j], options);
                        }
                        if (message.RuleName != null && message.hasOwnProperty("RuleName"))
                            object.RuleName = message.RuleName;
                        if (message.SatelliteCount != null && message.hasOwnProperty("SatelliteCount")) {
                            if (typeof message.SatelliteCount === "number")
                                object.SatelliteCount = options.longs === String ? String(message.SatelliteCount) : message.SatelliteCount;
                            else
                                object.SatelliteCount = options.longs === String ? $util.Long.prototype.toString.call(message.SatelliteCount) : options.longs === Number ? new $util.LongBits(message.SatelliteCount.low >>> 0, message.SatelliteCount.high >>> 0).toNumber() : message.SatelliteCount;
                            if (options.oneofs)
                                object._SatelliteCount = "SatelliteCount";
                        }
                        if (message.Hdop != null && message.hasOwnProperty("Hdop")) {
                            object.Hdop = options.json && !isFinite(message.Hdop) ? String(message.Hdop) : message.Hdop;
                            if (options.oneofs)
                                object._Hdop = "Hdop";
                        }
                        if (message.Vdop != null && message.hasOwnProperty("Vdop")) {
                            object.Vdop = options.json && !isFinite(message.Vdop) ? String(message.Vdop) : message.Vdop;
                            if (options.oneofs)
                                object._Vdop = "Vdop";
                        }
                        if (message.HorizontalAccuracy != null && message.hasOwnProperty("HorizontalAccuracy")) {
                            object.HorizontalAccuracy = options.json && !isFinite(message.HorizontalAccuracy) ? String(message.HorizontalAccuracy) : message.HorizontalAccuracy;
                            if (options.oneofs)
                                object._HorizontalAccuracy = "HorizontalAccuracy";
                        }
                        if (message.VerticalAccuracy != null && message.hasOwnProperty("VerticalAccuracy")) {
                            object.VerticalAccuracy = options.json && !isFinite(message.VerticalAccuracy) ? String(message.VerticalAccuracy) : message.VerticalAccuracy;
                            if (options.oneofs)
                                object._VerticalAccuracy = "VerticalAccuracy";
                        }
                        if (message.ValidFix != null && message.hasOwnProperty("ValidFix"))
                            object.ValidFix = message.ValidFix;
                        if (message.GpsAntennaStatus != null && message.hasOwnProperty("GpsAntennaStatus")) {
                            object.GpsAntennaStatus = message.GpsAntennaStatus;
                            if (options.oneofs)
                                object._GpsAntennaStatus = "GpsAntennaStatus";
                        }
                        if (message.MessageQuality != null && message.hasOwnProperty("MessageQuality"))
                            object.MessageQuality = message.MessageQuality;
                        if (message.SelfTestFaultCount != null && message.hasOwnProperty("SelfTestFaultCount"))
                            object.SelfTestFaultCount = message.SelfTestFaultCount;
                        if (message.SelfTestFailures && message.SelfTestFailures.length) {
                            object.SelfTestFailures = [];
                            for (let j = 0; j < message.SelfTestFailures.length; ++j)
                                object.SelfTestFailures[j] = $root.Wabtec.DataPlatform.Common.Investigations.SelfTestFailure.toObject(message.SelfTestFailures[j], options);
                        }
                        if (message.OtherVehicleDistance != null && message.hasOwnProperty("OtherVehicleDistance")) {
                            object.OtherVehicleDistance = options.json && !isFinite(message.OtherVehicleDistance) ? String(message.OtherVehicleDistance) : message.OtherVehicleDistance;
                            if (options.oneofs)
                                object._OtherVehicleDistance = "OtherVehicleDistance";
                        }
                        if (message.Audible != null && message.hasOwnProperty("Audible")) {
                            object.Audible = message.Audible;
                            if (options.oneofs)
                                object._Audible = "Audible";
                        }
                        if (message.EntryType != null && message.hasOwnProperty("EntryType"))
                            object.EntryType = options.enums === String ? $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.TrackEntryType[message.EntryType] === undefined ? message.EntryType : $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.TrackEntryType[message.EntryType] : message.EntryType;
                        if (message.InnerBeamLength != null && message.hasOwnProperty("InnerBeamLength")) {
                            object.InnerBeamLength = options.json && !isFinite(message.InnerBeamLength) ? String(message.InnerBeamLength) : message.InnerBeamLength;
                            if (options.oneofs)
                                object._InnerBeamLength = "InnerBeamLength";
                        }
                        if (message.OuterBeamLength != null && message.hasOwnProperty("OuterBeamLength")) {
                            object.OuterBeamLength = options.json && !isFinite(message.OuterBeamLength) ? String(message.OuterBeamLength) : message.OuterBeamLength;
                            if (options.oneofs)
                                object._OuterBeamLength = "OuterBeamLength";
                        }
                        if (message.MotiveState != null && message.hasOwnProperty("MotiveState")) {
                            object.MotiveState = message.MotiveState;
                            if (options.oneofs)
                                object._MotiveState = "MotiveState";
                        }
                        if (message.Payload != null && message.hasOwnProperty("Payload")) {
                            object.Payload = message.Payload;
                            if (options.oneofs)
                                object._Payload = "Payload";
                        }
                        if (message.Gradient != null && message.hasOwnProperty("Gradient")) {
                            object.Gradient = options.json && !isFinite(message.Gradient) ? String(message.Gradient) : message.Gradient;
                            if (options.oneofs)
                                object._Gradient = "Gradient";
                        }
                        if (message.Level9Active != null && message.hasOwnProperty("Level9Active")) {
                            object.Level9Active = message.Level9Active;
                            if (options.oneofs)
                                object._Level9Active = "Level9Active";
                        }
                        if (message.Level9Action != null && message.hasOwnProperty("Level9Action")) {
                            object.Level9Action = message.Level9Action;
                            if (options.oneofs)
                                object._Level9Action = "Level9Action";
                        }
                        if (message.Level9Level != null && message.hasOwnProperty("Level9Level")) {
                            object.Level9Level = message.Level9Level;
                            if (options.oneofs)
                                object._Level9Level = "Level9Level";
                        }
                        if (message.OtherVehicleName != null && message.hasOwnProperty("OtherVehicleName")) {
                            object.OtherVehicleName = message.OtherVehicleName;
                            if (options.oneofs)
                                object._OtherVehicleName = "OtherVehicleName";
                        }
                        if (message.OtherVehicleIsDotNetix != null && message.hasOwnProperty("OtherVehicleIsDotNetix")) {
                            object.OtherVehicleIsDotNetix = message.OtherVehicleIsDotNetix;
                            if (options.oneofs)
                                object._OtherVehicleIsDotNetix = "OtherVehicleIsDotNetix";
                        }
                        if (message.InteractionCharacteristics && message.InteractionCharacteristics.length) {
                            object.InteractionCharacteristics = [];
                            for (let j = 0; j < message.InteractionCharacteristics.length; ++j)
                                object.InteractionCharacteristics[j] = options.enums === String ? $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.InteractionCharacteristicsType[message.InteractionCharacteristics[j]] === undefined ? message.InteractionCharacteristics[j] : $root.Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.InteractionCharacteristicsType[message.InteractionCharacteristics[j]] : message.InteractionCharacteristics[j];
                        }
                        if (message.HorizAccuracySecondaryGNSS != null && message.hasOwnProperty("HorizAccuracySecondaryGNSS")) {
                            object.HorizAccuracySecondaryGNSS = options.json && !isFinite(message.HorizAccuracySecondaryGNSS) ? String(message.HorizAccuracySecondaryGNSS) : message.HorizAccuracySecondaryGNSS;
                            if (options.oneofs)
                                object._HorizAccuracySecondaryGNSS = "HorizAccuracySecondaryGNSS";
                        }
                        return object;
                    };

                    /**
                     * Converts this RawTrackEntry to JSON.
                     * @function toJSON
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RawTrackEntry.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RawTrackEntry
                     * @function getTypeUrl
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawTrackEntry
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RawTrackEntry.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/Wabtec.DataPlatform.Common.Investigations.RawTrackEntry";
                    };

                    /**
                     * TrackEntryType enum.
                     * @name Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.TrackEntryType
                     * @enum {number}
                     * @property {number} None=0 None value
                     * @property {number} InteractionStart=1 InteractionStart value
                     * @property {number} InteractionEnd=2 InteractionEnd value
                     */
                    RawTrackEntry.TrackEntryType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "None"] = 0;
                        values[valuesById[1] = "InteractionStart"] = 1;
                        values[valuesById[2] = "InteractionEnd"] = 2;
                        return values;
                    })();

                    /**
                     * InteractionCharacteristicsType enum.
                     * @name Wabtec.DataPlatform.Common.Investigations.RawTrackEntry.InteractionCharacteristicsType
                     * @enum {number}
                     * @property {number} IntersectionGeofence=0 IntersectionGeofence value
                     * @property {number} WetRoadGeofence=1 WetRoadGeofence value
                     * @property {number} SlopedGeofence=2 SlopedGeofence value
                     * @property {number} WetRoad=3 WetRoad value
                     * @property {number} Roadworks=4 Roadworks value
                     * @property {number} Loaded=5 Loaded value
                     * @property {number} Intervention=6 Intervention value
                     */
                    RawTrackEntry.InteractionCharacteristicsType = (function() {
                        const valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "IntersectionGeofence"] = 0;
                        values[valuesById[1] = "WetRoadGeofence"] = 1;
                        values[valuesById[2] = "SlopedGeofence"] = 2;
                        values[valuesById[3] = "WetRoad"] = 3;
                        values[valuesById[4] = "Roadworks"] = 4;
                        values[valuesById[5] = "Loaded"] = 5;
                        values[valuesById[6] = "Intervention"] = 6;
                        return values;
                    })();

                    return RawTrackEntry;
                })();

                Investigations.SelfTestFailure = (function() {

                    /**
                     * Properties of a SelfTestFailure.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @interface ISelfTestFailure
                     * @property {number|null} [Category] SelfTestFailure Category
                     * @property {number|null} [Id] SelfTestFailure Id
                     * @property {number|null} [Level] SelfTestFailure Level
                     */

                    /**
                     * Constructs a new SelfTestFailure.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @classdesc Represents a SelfTestFailure.
                     * @implements ISelfTestFailure
                     * @constructor
                     * @param {Wabtec.DataPlatform.Common.Investigations.ISelfTestFailure=} [properties] Properties to set
                     */
                    function SelfTestFailure(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * SelfTestFailure Category.
                     * @member {number} Category
                     * @memberof Wabtec.DataPlatform.Common.Investigations.SelfTestFailure
                     * @instance
                     */
                    SelfTestFailure.prototype.Category = 0;

                    /**
                     * SelfTestFailure Id.
                     * @member {number} Id
                     * @memberof Wabtec.DataPlatform.Common.Investigations.SelfTestFailure
                     * @instance
                     */
                    SelfTestFailure.prototype.Id = 0;

                    /**
                     * SelfTestFailure Level.
                     * @member {number} Level
                     * @memberof Wabtec.DataPlatform.Common.Investigations.SelfTestFailure
                     * @instance
                     */
                    SelfTestFailure.prototype.Level = 0;

                    /**
                     * Decodes a SelfTestFailure message from the specified reader or buffer.
                     * @function decode
                     * @memberof Wabtec.DataPlatform.Common.Investigations.SelfTestFailure
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {Wabtec.DataPlatform.Common.Investigations.SelfTestFailure} SelfTestFailure
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SelfTestFailure.decode = function decode(reader, length, error, long) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (long === undefined)
                            long = 0;
                        if (long > $Reader.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Wabtec.DataPlatform.Common.Investigations.SelfTestFailure();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.Category = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.Id = reader.int32();
                                    break;
                                }
                            case 3: {
                                    message.Level = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7, long);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a SelfTestFailure message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.SelfTestFailure
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {Wabtec.DataPlatform.Common.Investigations.SelfTestFailure} SelfTestFailure
                     */
                    SelfTestFailure.fromObject = function fromObject(object, long) {
                        if (object instanceof $root.Wabtec.DataPlatform.Common.Investigations.SelfTestFailure)
                            return object;
                        if (long === undefined)
                            long = 0;
                        if (long > $util.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let message = new $root.Wabtec.DataPlatform.Common.Investigations.SelfTestFailure();
                        if (object.Category != null)
                            message.Category = object.Category | 0;
                        if (object.Id != null)
                            message.Id = object.Id | 0;
                        if (object.Level != null)
                            message.Level = object.Level | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a SelfTestFailure message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.SelfTestFailure
                     * @static
                     * @param {Wabtec.DataPlatform.Common.Investigations.SelfTestFailure} message SelfTestFailure
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SelfTestFailure.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.Category = 0;
                            object.Id = 0;
                            object.Level = 0;
                        }
                        if (message.Category != null && message.hasOwnProperty("Category"))
                            object.Category = message.Category;
                        if (message.Id != null && message.hasOwnProperty("Id"))
                            object.Id = message.Id;
                        if (message.Level != null && message.hasOwnProperty("Level"))
                            object.Level = message.Level;
                        return object;
                    };

                    /**
                     * Converts this SelfTestFailure to JSON.
                     * @function toJSON
                     * @memberof Wabtec.DataPlatform.Common.Investigations.SelfTestFailure
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SelfTestFailure.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for SelfTestFailure
                     * @function getTypeUrl
                     * @memberof Wabtec.DataPlatform.Common.Investigations.SelfTestFailure
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    SelfTestFailure.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/Wabtec.DataPlatform.Common.Investigations.SelfTestFailure";
                    };

                    return SelfTestFailure;
                })();

                Investigations.RawNameToId = (function() {

                    /**
                     * Properties of a RawNameToId.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @interface IRawNameToId
                     * @property {string|null} [RawName] RawNameToId RawName
                     * @property {number|Long|null} [Id] RawNameToId Id
                     */

                    /**
                     * Constructs a new RawNameToId.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @classdesc Represents a RawNameToId.
                     * @implements IRawNameToId
                     * @constructor
                     * @param {Wabtec.DataPlatform.Common.Investigations.IRawNameToId=} [properties] Properties to set
                     */
                    function RawNameToId(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RawNameToId RawName.
                     * @member {string} RawName
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawNameToId
                     * @instance
                     */
                    RawNameToId.prototype.RawName = "";

                    /**
                     * RawNameToId Id.
                     * @member {number|Long|null|undefined} Id
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawNameToId
                     * @instance
                     */
                    RawNameToId.prototype.Id = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * RawNameToId _Id.
                     * @member {"Id"|undefined} _Id
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawNameToId
                     * @instance
                     */
                    Object.defineProperty(RawNameToId.prototype, "_Id", {
                        get: $util.oneOfGetter($oneOfFields = ["Id"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Decodes a RawNameToId message from the specified reader or buffer.
                     * @function decode
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawNameToId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {Wabtec.DataPlatform.Common.Investigations.RawNameToId} RawNameToId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawNameToId.decode = function decode(reader, length, error, long) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (long === undefined)
                            long = 0;
                        if (long > $Reader.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Wabtec.DataPlatform.Common.Investigations.RawNameToId();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.RawName = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.Id = reader.int64();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7, long);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a RawNameToId message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawNameToId
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {Wabtec.DataPlatform.Common.Investigations.RawNameToId} RawNameToId
                     */
                    RawNameToId.fromObject = function fromObject(object, long) {
                        if (object instanceof $root.Wabtec.DataPlatform.Common.Investigations.RawNameToId)
                            return object;
                        if (long === undefined)
                            long = 0;
                        if (long > $util.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let message = new $root.Wabtec.DataPlatform.Common.Investigations.RawNameToId();
                        if (object.RawName != null)
                            message.RawName = String(object.RawName);
                        if (object.Id != null)
                            if ($util.Long)
                                (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                            else if (typeof object.Id === "string")
                                message.Id = parseInt(object.Id, 10);
                            else if (typeof object.Id === "number")
                                message.Id = object.Id;
                            else if (typeof object.Id === "object")
                                message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
                        return message;
                    };

                    /**
                     * Creates a plain object from a RawNameToId message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawNameToId
                     * @static
                     * @param {Wabtec.DataPlatform.Common.Investigations.RawNameToId} message RawNameToId
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RawNameToId.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.RawName = "";
                        if (message.RawName != null && message.hasOwnProperty("RawName"))
                            object.RawName = message.RawName;
                        if (message.Id != null && message.hasOwnProperty("Id")) {
                            if (typeof message.Id === "number")
                                object.Id = options.longs === String ? String(message.Id) : message.Id;
                            else
                                object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                            if (options.oneofs)
                                object._Id = "Id";
                        }
                        return object;
                    };

                    /**
                     * Converts this RawNameToId to JSON.
                     * @function toJSON
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawNameToId
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RawNameToId.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RawNameToId
                     * @function getTypeUrl
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawNameToId
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RawNameToId.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/Wabtec.DataPlatform.Common.Investigations.RawNameToId";
                    };

                    return RawNameToId;
                })();

                Investigations.RawIdToIdAndName = (function() {

                    /**
                     * Properties of a RawIdToIdAndName.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @interface IRawIdToIdAndName
                     * @property {number|Long|null} [RawId] RawIdToIdAndName RawId
                     * @property {number|Long|null} [Id] RawIdToIdAndName Id
                     * @property {string|null} [Name] RawIdToIdAndName Name
                     */

                    /**
                     * Constructs a new RawIdToIdAndName.
                     * @memberof Wabtec.DataPlatform.Common.Investigations
                     * @classdesc Represents a RawIdToIdAndName.
                     * @implements IRawIdToIdAndName
                     * @constructor
                     * @param {Wabtec.DataPlatform.Common.Investigations.IRawIdToIdAndName=} [properties] Properties to set
                     */
                    function RawIdToIdAndName(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null && keys[i] !== "__proto__")
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RawIdToIdAndName RawId.
                     * @member {number|Long} RawId
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @instance
                     */
                    RawIdToIdAndName.prototype.RawId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                    /**
                     * RawIdToIdAndName Id.
                     * @member {number|Long|null|undefined} Id
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @instance
                     */
                    RawIdToIdAndName.prototype.Id = null;

                    /**
                     * RawIdToIdAndName Name.
                     * @member {string|null|undefined} Name
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @instance
                     */
                    RawIdToIdAndName.prototype.Name = null;

                    // OneOf field names bound to virtual getters and setters
                    let $oneOfFields;

                    /**
                     * RawIdToIdAndName _Id.
                     * @member {"Id"|undefined} _Id
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @instance
                     */
                    Object.defineProperty(RawIdToIdAndName.prototype, "_Id", {
                        get: $util.oneOfGetter($oneOfFields = ["Id"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * RawIdToIdAndName _Name.
                     * @member {"Name"|undefined} _Name
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @instance
                     */
                    Object.defineProperty(RawIdToIdAndName.prototype, "_Name", {
                        get: $util.oneOfGetter($oneOfFields = ["Name"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });

                    /**
                     * Decodes a RawIdToIdAndName message from the specified reader or buffer.
                     * @function decode
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName} RawIdToIdAndName
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawIdToIdAndName.decode = function decode(reader, length, error, long) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        if (long === undefined)
                            long = 0;
                        if (long > $Reader.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            if (tag === error)
                                break;
                            switch (tag >>> 3) {
                            case 1: {
                                    message.RawId = reader.int64();
                                    break;
                                }
                            case 2: {
                                    message.Id = reader.int64();
                                    break;
                                }
                            case 3: {
                                    message.Name = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7, long);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a RawIdToIdAndName message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName} RawIdToIdAndName
                     */
                    RawIdToIdAndName.fromObject = function fromObject(object, long) {
                        if (object instanceof $root.Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName)
                            return object;
                        if (long === undefined)
                            long = 0;
                        if (long > $util.recursionLimit)
                            throw Error("maximum nesting depth exceeded");
                        let message = new $root.Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName();
                        if (object.RawId != null)
                            if ($util.Long)
                                (message.RawId = $util.Long.fromValue(object.RawId)).unsigned = false;
                            else if (typeof object.RawId === "string")
                                message.RawId = parseInt(object.RawId, 10);
                            else if (typeof object.RawId === "number")
                                message.RawId = object.RawId;
                            else if (typeof object.RawId === "object")
                                message.RawId = new $util.LongBits(object.RawId.low >>> 0, object.RawId.high >>> 0).toNumber();
                        if (object.Id != null)
                            if ($util.Long)
                                (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                            else if (typeof object.Id === "string")
                                message.Id = parseInt(object.Id, 10);
                            else if (typeof object.Id === "number")
                                message.Id = object.Id;
                            else if (typeof object.Id === "object")
                                message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
                        if (object.Name != null)
                            message.Name = String(object.Name);
                        return message;
                    };

                    /**
                     * Creates a plain object from a RawIdToIdAndName message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @static
                     * @param {Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName} message RawIdToIdAndName
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RawIdToIdAndName.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                let long = new $util.Long(0, 0, false);
                                object.RawId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.RawId = options.longs === String ? "0" : 0;
                        if (message.RawId != null && message.hasOwnProperty("RawId"))
                            if (typeof message.RawId === "number")
                                object.RawId = options.longs === String ? String(message.RawId) : message.RawId;
                            else
                                object.RawId = options.longs === String ? $util.Long.prototype.toString.call(message.RawId) : options.longs === Number ? new $util.LongBits(message.RawId.low >>> 0, message.RawId.high >>> 0).toNumber() : message.RawId;
                        if (message.Id != null && message.hasOwnProperty("Id")) {
                            if (typeof message.Id === "number")
                                object.Id = options.longs === String ? String(message.Id) : message.Id;
                            else
                                object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                            if (options.oneofs)
                                object._Id = "Id";
                        }
                        if (message.Name != null && message.hasOwnProperty("Name")) {
                            object.Name = message.Name;
                            if (options.oneofs)
                                object._Name = "Name";
                        }
                        return object;
                    };

                    /**
                     * Converts this RawIdToIdAndName to JSON.
                     * @function toJSON
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RawIdToIdAndName.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RawIdToIdAndName
                     * @function getTypeUrl
                     * @memberof Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RawIdToIdAndName.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/Wabtec.DataPlatform.Common.Investigations.RawIdToIdAndName";
                    };

                    return RawIdToIdAndName;
                })();

                return Investigations;
            })();

            return Common;
        })();

        return DataPlatform;
    })();

    return Wabtec;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             */
            function Timestamp(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null && keys[i] !== "__proto__")
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(reader, length, error, long) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                if (long === undefined)
                    long = 0;
                if (long > $Reader.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.seconds = reader.int64();
                            break;
                        }
                    case 2: {
                            message.nanos = reader.int32();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7, long);
                        break;
                    }
                }
                return message;
            };

            /**
             * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Timestamp} Timestamp
             */
            Timestamp.fromObject = function fromObject(object, long) {
                if (object instanceof $root.google.protobuf.Timestamp)
                    return object;
                if (long === undefined)
                    long = 0;
                if (long > $util.recursionLimit)
                    throw Error("maximum nesting depth exceeded");
                let message = new $root.google.protobuf.Timestamp();
                if (object.seconds != null)
                    if ($util.Long)
                        (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                    else if (typeof object.seconds === "string")
                        message.seconds = parseInt(object.seconds, 10);
                    else if (typeof object.seconds === "number")
                        message.seconds = object.seconds;
                    else if (typeof object.seconds === "object")
                        message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                if (object.nanos != null)
                    message.nanos = object.nanos | 0;
                return message;
            };

            /**
             * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.Timestamp} message Timestamp
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Timestamp.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.seconds = options.longs === String ? "0" : 0;
                    object.nanos = 0;
                }
                if (message.seconds != null && message.hasOwnProperty("seconds"))
                    if (typeof message.seconds === "number")
                        object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                    else
                        object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                if (message.nanos != null && message.hasOwnProperty("nanos"))
                    object.nanos = message.nanos;
                return object;
            };

            /**
             * Converts this Timestamp to JSON.
             * @function toJSON
             * @memberof google.protobuf.Timestamp
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Timestamp
             * @function getTypeUrl
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Timestamp.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/google.protobuf.Timestamp";
            };

            return Timestamp;
        })();

        return protobuf;
    })();

    return google;
})();

export { $root as default };
